import { corneredBadgeDefinition } from './definitions/cornered'
import { doubleDoubleBadgeDefinition } from './definitions/doubleDouble'
import { explorerBadgeDefinition } from './definitions/explorer'
import { isogramBadgeDefinition } from './definitions/isogram'
import { longStartBadgeDefinition } from './definitions/longStart'
import { luckyCharmBadgeDefinition } from './definitions/luckyCharm'
import { masterBadgeDefinition } from './definitions/master'
import { palindromeBadgeDefinition } from './definitions/palindrome'
import { sorcererBadgeDefinition } from './definitions/sorcerer'
import { spellingBeeBadgeDefinition } from './definitions/spellingBee'
import { squareBadgeDefinition } from './definitions/square'
import { straightBadgeDefinition } from './definitions/straight'
import { straightForwardBadgeDefinition } from './definitions/straightForward'
import { strongStartBadgeDefinition } from './definitions/strongStart'
import { tartarSauceBadgeDefinition } from './definitions/tartarSauce'
import { verboseBadgeDefinition } from './definitions/verbose'
import { BOGGLE_TIERED_BADGE_DEFINITIONS } from './expandTieredFamilies'
import type { BoggleBadgeDefinition, BoggleBadgeId } from './types'

const BOGGLE_FLAT_BADGE_DEFINITIONS: readonly BoggleBadgeDefinition[] = [
  corneredBadgeDefinition,
  squareBadgeDefinition,
  tartarSauceBadgeDefinition,
  palindromeBadgeDefinition,
  isogramBadgeDefinition,
  doubleDoubleBadgeDefinition,
  explorerBadgeDefinition,
  spellingBeeBadgeDefinition,
  luckyCharmBadgeDefinition,
  longStartBadgeDefinition,
  masterBadgeDefinition,
  sorcererBadgeDefinition,
  straightBadgeDefinition,
  straightForwardBadgeDefinition,
  strongStartBadgeDefinition,
  verboseBadgeDefinition,
]

/**
 * Authored badge list. Order is the stable authored fallback when two badges
 * are earned at the same ledger entry; tiered family tiers are appended after
 * flat badges in family order.
 */
export const BOGGLE_BADGE_DEFINITIONS: readonly BoggleBadgeDefinition[] = [
  ...BOGGLE_FLAT_BADGE_DEFINITIONS,
  ...BOGGLE_TIERED_BADGE_DEFINITIONS,
]

const BOGGLE_BADGE_REGISTRY: Record<BoggleBadgeId, BoggleBadgeDefinition> =
  Object.fromEntries(
    BOGGLE_BADGE_DEFINITIONS.map(definition => [definition.id, definition]),
  ) as Record<BoggleBadgeId, BoggleBadgeDefinition>

export function getBoggleBadgeDefinition(badgeId: BoggleBadgeId) {
  return BOGGLE_BADGE_REGISTRY[badgeId]
}

/** Stable authored sort key used to break ties at the same ledger index. */
export function getBoggleBadgeAuthoredOrder(badgeId: BoggleBadgeId) {
  return BOGGLE_BADGE_DEFINITIONS.findIndex(definition => definition.id === badgeId)
}
